/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Details_Archive_Reason_ArchivedInputs */

const fr_vehicle_details_archive_reason_archived = /** @type {(inputs: Vehicle_Details_Archive_Reason_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a été archivé`)
};

const en_vehicle_details_archive_reason_archived = /** @type {(inputs: Vehicle_Details_Archive_Reason_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`was archived`)
};

/**
* | output |
* | --- |
* | "was archived" |
*
* @param {Vehicle_Details_Archive_Reason_ArchivedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_details_archive_reason_archived = /** @type {((inputs?: Vehicle_Details_Archive_Reason_ArchivedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Details_Archive_Reason_ArchivedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_details_archive_reason_archived(inputs)
	return en_vehicle_details_archive_reason_archived(inputs)
});